import { FunctionComponent, useState } from "react";
import { TextInput } from "../inputs";
import { Button } from "../generic";
import { sendgrid } from "src/utils";

interface IBasicInfoFormProps {
    confirmSubmit: (value: boolean) => void;
    setStudentName: (value: string) => void;
    setStudentEmail: (value: string) => void;
}

const BasicInfoForm: FunctionComponent<IBasicInfoFormProps> = ({ confirmSubmit, setStudentName, setStudentEmail }) => {
    const [error, setError] = useState<string | null>(null);
    const [name, setName] = useState<string>('');
    const [email, setEmail] = useState<string>('');

    const submit = async (event: any) => {
        console.log(name, email)
        event?.preventDefault();
        try {
            if(!name || !email || !email.includes('@')) return setError('Please Enter Name & Email');

            const result = await sendgrid.sendStudentStartedQuiz(name, email, 'Credit Basics 101');

            console.log({result});
            setStudentName(name);
            setStudentEmail(email);
            confirmSubmit(true);
        } catch(error: any) {
            setError(error?.message || 'Failed To Save Information')
        }
    }

    return (
        <div className="text-center flex flex-col justify-center items-center py-8">
            <form className="w-[50%] border border-primary rounded-md py-16 px-12">
                <div className="mb-24">
                    <h4 className="mb-4 text-2xl font-medium">Credit Basics Quiz (101)</h4>
                    <p className="text-md">Enter full name and email address for registration and to receive your certificate upon completion and receiving 100% on the quiz.</p>
                </div>
                {error && <p className="text-danger mb-4">{error}</p>}
                <TextInput
                    id='name'
                    placeholder="Name..."
                    value={name}
                    onChange={(value: string) => setName(value)}
                    containerStyles="mb-8"
                />

                <TextInput
                    id='email'
                    placeholder="Email..."
                    value={email}
                    onChange={(value: string) => setEmail(value)}
                    containerStyles="mb-12"
                />
                <Button
                    text="Submit"
                    onClick={submit}
                />
            </form>
        </div>
    );
}

export default BasicInfoForm;